import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "./auth/auth-guard.service";

import { RouteLoggedComponent } from "./core/route-logged/route-logged.component";
import { HorsesComponent } from "./custom/horses/horses.component";
import { HorseComponent } from "./custom/horse/horse.component";
import { ProfileComponent } from "./custom/profile/profile.component";
import { CatComponent } from "./custom/cat/cat.component";
import { RuleBookComponent } from "./custom/rule-book/rule-book.component";
import { AdminReportComponent } from "./custom/admin-report/admin-report.component";
import { AboutComponent } from "./custom/about/about.component";
import { ContactComponent } from "./custom/contact/contact.component";
import { AllTreatmentsComponent } from "./custom/all-treatments/all-treatments.component";
import { YardsComponent } from "./custom/yards/yards.component";
import { WeightReportingComponent } from "./custom/weight-reporting/weight-reporting.component";
import { BillingComponent } from "./custom/billing/billing.component";
import { InvoicesComponent } from "./custom/invoices/invoices.component";
import { InfoComponent } from "./custom/info/info.component";
import { KaynaInsuranceComponent } from "./custom/insurance/kayna/kayna.component";
import { InsuranceListingComponent } from "./custom/insurance/insurancelisting.component";
import { CountryGuard } from "./auth/country-guard.service";

const routes: Routes = [
  {
    path: "",
    component: RouteLoggedComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "horses",
        pathMatch: "full",
        canActivate: [AuthGuard],
      },
      {
        path: "horses",
        component: HorsesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "yards/horses/:yard_id/:en_region",
        component: HorsesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "horses/:horse_id",
        component: HorseComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "profile",
        component: ProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "cat",
        component: CatComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "admin-report",
        component: AdminReportComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      {
        path: "weight-reporting",
        component: WeightReportingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: "rules-book",
        component: RuleBookComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      // {
      //   path: 'about',
      //   component: AboutComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: "contact",
        component: ContactComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      {
        path: "all-treatments",
        component: AllTreatmentsComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      {
        path: "yards",
        component: YardsComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      {
        path: "billing",
        component: BillingComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      {
        path: "invoices",
        component: InvoicesComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      {
        path: "info",
        component: InfoComponent,
        canActivate: [AuthGuard, CountryGuard],
      },
      // Insurance listing - hidden from all users until re-enabled
      // {
      //   path: "insurance",
      //   component: InsuranceListingComponent,
      //   canActivate: [AuthGuard, CountryGuard],
      // },
      // Kayna insurance widget - hidden from all users until re-enabled
      // {
      //   path: "kayna-insurance",
      //   component: KaynaInsuranceComponent,
      //   canActivate: [AuthGuard, CountryGuard],
      // }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/app-routing.module.ts